import { useTranslation } from 'react-i18next';
import { Retailer } from '@/types';

interface RetailerPolicyProps {
  retailer: Retailer;
  className?: string;
}

const RetailerPolicyLinks: React.FC<RetailerPolicyProps> = (props) => {
  const { retailer, className = '' } = props;
  const { t } = useTranslation();

  return (
    <div className={className}>
      <p className="font-bd text-2-2 mb-1-6">{t('retailer.links')}</p>
      <div className="grid grid-cols-1 gap-2-0">
        {retailer.imprint && (
          <div>
            <label className="text-gray-700 mb-0-5 block text-1-2">
              {t('retailer.policies.imprint')}
            </label>
            <div
              className="cursor-pointer mb-0 block w-full appearance-none rounded-8-0 border p-1-0 text-body1 leading-1-0 text-grey-800  focus:outline-none bg-secondary-grey"
              id="imprint"
              onClick={() => window.open(retailer.imprint || '', '_blank')}
            >
              <span className="underline">{retailer.imprint}</span>
            </div>
          </div>
        )}
        {retailer.msds && (
          <div>
            <label className="text-gray-700 mb-0-5 block text-1-2">
              {t('retailer.policies.msds')}
            </label>
            <div
              className="cursor-pointer mb-0 block w-full appearance-none rounded-8-0 border p-1-0 text-body1 leading-1-0 text-grey-800  focus:outline-none bg-secondary-grey"
              id="imprint"
              onClick={() => window.open(retailer.msds || '', '_blank')}
            >
              <span className="underline">{retailer.msds}</span>
            </div>
          </div>
        )}
        {retailer.dataProtection && (
          <div>
            <label className="text-gray-700 mb-0-5 block text-1-2">
              {t('retailer.policies.data_protection')}
            </label>
            <div
              className="cursor-pointer mb-0 block w-full appearance-none rounded-8-0 border p-1-0 text-body1 leading-1-0 text-grey-800  focus:outline-none bg-secondary-grey"
              id="imprint"
              onClick={() =>
                window.open(retailer.dataProtection || '', '_blank')
              }
            >
              <span className="underline">{retailer.dataProtection}</span>
            </div>
          </div>
        )}
        {retailer.termsAndConditions && (
          <div>
            <label className="text-gray-700 mb-0-5 block text-1-2">
              {t('retailer.policies.terms_and_conditions')}
            </label>
            <div
              className="cursor-pointer mb-0 block w-full appearance-none rounded-8-0 border p-1-0 text-body1 leading-1-0 text-grey-800  focus:outline-none bg-secondary-grey"
              id="imprint"
              onClick={() =>
                window.open(retailer.termsAndConditions || '', '_blank')
              }
            >
              <span className="underline">{retailer.termsAndConditions}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RetailerPolicyLinks;
